import axios from 'axios'
import { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'

export const useErpTaxRates = (company) => {
  const [taxRates, setTaxRates] = useState([])
  const [loading, setLoading] = useState(false)

  const companyTaxId = useMemo(() => company?.taxId, [company])
  const pin = useMemo(() => company?.pin, [company])
  const erpApi = useMemo(() => company?.ip, [company])

  useEffect(() => {
    const getAllTaxRate = async () => {
      if (!companyTaxId || !pin || !erpApi) return

      setLoading(true)
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_IP}/protocol/erp-tax-rate`, {
          taxId: Number(companyTaxId),
          pin,
          ip: erpApi,
        })

        setTaxRates(data?.data || [])
      } catch (error) {
        toast.error(error?.message || 'Greška')
      } finally {
        setLoading(false)
      }
    }

    getAllTaxRate()
  }, [companyTaxId, pin, erpApi])

  return {
    taxRates,
    loading,
  }
}
